import maps from "../maps";

export default {
    components: {maps},
    props: {
        shipping: {type: Object, default: null},
        countryShipping: {type: Object, default: () => ({})},
        points: {type: Array, default: () => []},
        selectedPoint: {type: Object, default: null},
        mapPostCode: {type: String, default: ""},
        zoom: {type: Number, default: 0},
        latitude: {type: Number, default: 0},
        longitude: {type: Number, default: 0},
        formatPrice: {type: Function, default: null},
    },
    emits: ["update:mapPostCode", "select", "select-from-list", "clear"],
    methods: {
        shippingPrices(prices, number = false, pointType = null) {
            if (this.$parent?.shippingPrices) {
                return this.$parent.shippingPrices(prices, number, pointType);
            }
            return prices;
        },
    },
    template: `
        <div v-show="shipping !== null && shipping.type==2" class="pure-u-1-1">
            <div class="mb-2">
                <div class="form-group">
                    <label v-if="countryShipping.postLocalName" for="search-post-code">{{ countryShipping.postLocalName }}</label>
                    <label v-else for="search-post-code">Postal code</label>
                    <input id="search-post-code" type="text" :value="mapPostCode" @input="$emit('update:mapPostCode', $event.target.value)">
                </div>
                <div v-if="selectedPoint">
                    <div class="pure-g">
                        <div class="pure-u-auto"><img :src="selectedPoint.icon" v-if="selectedPoint.icon" class="pure-img"></div>
                        <div class="pure-u">
                            <div class="fw-bold">{{ selectedPoint.name }}</div>
                            <div class="mt-1">{{ selectedPoint.postCode }}, {{ selectedPoint.city }} {{ selectedPoint.street }}</div>
                            <button type="button" class="btn btn-link p-0" @click="$emit('clear')">Select other</button>
                        </div>
                    </div>
                </div>
                <div class="max-h-55 scrollable" v-else>
                    <div class="form-group" v-for="(point,i) in points" :key="point.pointId">
                        <input :id="'point-'+i" type="radio" name="packagePoint" :value="point.pointId" @change="$emit('select-from-list')">
                        <label :for="'point-'+i" class="pure-g">
                            <div class="pure-u-1-4 pure-u-md-1-6 text-center">
                                <img :src="point.icon" alt="" class="pure-img cart-option-image">
                            </div>
                            <div class="pure-u-3-4 pure-u-md-2-3">{{ point.name }}</div>
                            <div class="d-none d-md-block pure-u-1-6 text-end">{{ shippingPrices(shipping.prices, false, point.type) }}</div>
                        </label>
                    </div>
                </div>
                <div>
                    <maps
                        api-key="AIzaSyA3eYyJXIRkkyAtu52povXrDEMwFcrPJo0"
                        :zoom="zoom"
                        :center="{ lat: latitude, lng: longitude }"
                        :points="points"
                        ref="map"
                        @selected="(point) => $emit('select', point)"
                    ></maps>
                </div>
            </div>
        </div>
    `,
};